import { useListStore, useMenuSortStore, useSortStore } from '../../hooks';
import { MenuCategoryListView } from '../../components/MenuCategoryListView';

export const MenuCategoryList = () => {
  const {
    loading,
    menuCategories,
    getMenus,
    onOpenMenuCategoryModal,
    onOpenMenuCategoryRegistrationModal,
    onOpenMenuRegistrationModal,
    onOpenMenuModal,
  } = useListStore();

  const {
    accordionIndex,
    onDragEndMenuCategories,
    checkOpenStateSortPopover,
    onCancelSort,
    onSort,
    onChangeAccordion,
  } = useSortStore();

  const {
    onDragStartMenus,
    onDragEndMenus,
    checkOpenStateSortPopoverMenu,
    onCancelSortMenu,
    onSortMenu,
  } = useMenuSortStore();

  return (
    <MenuCategoryListView
      loading={loading}
      listItems={menuCategories}
      handleChangeAccordion={onChangeAccordion}
      checkOpenStateSortPopover={checkOpenStateSortPopover}
      getNestedListItems={getMenus}
      accordionIndex={accordionIndex}
      handleClickAdd={onOpenMenuCategoryRegistrationModal}
      handleClickMenuCategoryRow={onOpenMenuCategoryModal}
      handleClickAddMenu={onOpenMenuRegistrationModal}
      handleClickMenuRow={onOpenMenuModal}
      handleDragEnd={onDragEndMenuCategories}
      handleCancelSort={onCancelSort}
      handleSort={onSort}
      handleDragStartMenus={onDragStartMenus}
      handleDragEndMenus={onDragEndMenus}
      checkOpenStateSortPopoverMenu={checkOpenStateSortPopoverMenu}
      handleCancelSortMenu={onCancelSortMenu}
      handleSortMenu={onSortMenu}
    />
  );
};
